import { QuizProvider } from 'contexts';
import { Route, Routes, useParams } from 'react-router-dom';
import { Quiz } from './quiz';
import { EditQuizQuestions } from 'components';
import { EditQuizPage } from './quiz-settings';
import { QuizSessionRouter } from './quiz-session';
import { PrintAnswerSheet } from './slideshow-quiz/print-answer-sheet';

export const QuizSetup = () => {
    const params = useParams();
    const quizId = parseInt(params.quizId!);

    return (
        <QuizProvider quizId={quizId}>
            <Routes>
                {/* TODO - use a more general edit for a quiz */}
                <Route path="/questions/edit" element={<EditQuizQuestions />} />
                <Route path="/edit" element={<EditQuizPage />} />
                <Route path="/session/:sessionKey/*" element={<QuizSessionRouter />} />
                <Route path="/answer-sheet-print" element={<PrintAnswerSheet />} />
                <Route path="/" element={<Quiz />} />
                <Route path="*" element={<Quiz />} />
            </Routes>
        </QuizProvider>
    );
};
